/* eslint-disable  */

import React, {Component} from 'react';
import {Button, Checkbox, Col, Grid, HelpBlock, Radio, Row, ControlLabel, FormControl, FormGroup, Glyphicon, InputGroup} from 'react-bootstrap';
import DatePicker from '../common/form/datepicker';
import FilteredDropdown from '../common/form/filtered-dropdown';
import MultiSelect from '../common/form/multi-select';
import Spinner from '../common/form/spinner';
import RangeSlider from '../common/form/range-slider';
import PageTitle from '../common/page-title/index';
import {Modal} from 'react-bootstrap';
import IgniteDataTable from '../common/datatable/index';
import FileUpload from "../common/form/elements/file-upload";
import { Form } from "react-redux-form";

const options = [
  {
    value: 'one',
    label: 'One'
  },
  {
    value: 'two',
    label: 'Two'
  },
  {
    value: 'three',
    label: 'Three'
  }
];

class SiteDesign extends Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    return (
      <div className="container-fluid">
        <PageTitle>Site Design Page</PageTitle>
        <h1>Heading 1 (Tag: h1, @mixin: heading-1)</h1>
        <h2>Heading 2 (Tag: h2, @mixin: heading-2)</h2>
        <h3>Heading 3 (Tag: h3, @mixin: heading-3)</h3>
        <h4>Heading 4 (Tag: h4, @mixin: heading-4)</h4>
        <h5>Heading 5 (Tag: h5, @mixin: heading-5)</h5>
        <h6>Heading 6 (Tag: h6, @mixin: heading-6)</h6>

        <h1>Paragraphs (tag: p, @mixin: paragraph)</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus condimentum suscipit lorem vitae
          consectetur. Quisque tempus sit amet leo eget accumsan. Suspendisse pretium vulputate dapibus.
          Pellentesque pretium, lectus sagittis pellentesque vulputate, neque turpis cursus nulla, vitae
          pharetra est nulla et neque. Phasellus pharetra tortor at lacus auctor pharetra. Sed vitae odio
          arcu. Fusce cursus libero turpis, sed finibus mi aliquet ac.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus condimentum suscipit lorem vitae
          consectetur. Quisque tempus sit amet leo eget accumsan. Suspendisse pretium vulputate dapibus.
          Pellentesque pretium, lectus sagittis pellentesque vulputate, neque turpis cursus nulla, vitae
          pharetra est nulla et neque. Phasellus pharetra tortor at lacus auctor pharetra. Sed vitae odio
          arcu. Fusce cursus libero turpis, sed finibus mi aliquet ac.
        </p>

        <h1>TODO Custom lists</h1>

        <h1>Forms</h1>
        <Form model="deep.submission">
          <FormGroup>
            <ControlLabel>Default input field</ControlLabel>
            <FormControl type="text" value="Text input field"/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Password</ControlLabel>
            <FormControl type="password" value="Text input field"/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>With Placeholder</ControlLabel>
            <FormControl type="text" placeholder="With placeholder"/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Disabled field</ControlLabel>
            <FormControl disabled type="text" value="disabled field"/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Readonly field</ControlLabel>
            <FormControl className="read-only" type="text" value="readonly field"/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Help text field</ControlLabel>
            <FormControl type="text" value=""/>
            <span className="help-block">
                        A block of help text that breaks onto a new line and may extend beyond one line.
                        </span>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Predefined value</ControlLabel>
            <FormControl type="text" value="http://"/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Column sizing</ControlLabel>
            <Grid fluid>
              <Row>
                <Col xs={6}>
                  <FormControl type="text" placeholder=".col-xs-6"/>
                </Col>
                <Col xs={10}>
                  <FormControl type="text" placeholder=".col-xs-10"/>
                </Col>
                <Col xs={8}>
                  <FormControl type="text" placeholder=".col-xs-8"/>
                </Col>
              </Row>
            </Grid>
          </FormGroup>
          <FormGroup controlId="formValidationSuccess2" validationState="success">
            <ControlLabel>Input with success and feedback icon</ControlLabel>
            <FormControl type="text"/>
            <FormControl.Feedback/>
          </FormGroup>
          <FormGroup controlId="formValidationWarning2" validationState="warning">
            <ControlLabel>Input with warning and feedback icon</ControlLabel>
            <FormControl type="text"/>
            <FormControl.Feedback/>
          </FormGroup>
          <FormGroup controlId="formValidationError2" validationState="error">
            <ControlLabel>Input with error and feedback icon</ControlLabel>
            <FormControl type="text"/>
            <HelpBlock>Validation message come here</HelpBlock>
            <FormControl.Feedback/>
          </FormGroup>
          <h4>DatePicker</h4>
          <DatePicker/>
          <h4>FilteredDropdown</h4>
          <FilteredDropdown data={options} value={{
            label: 'Selected option',
            value: 'value'
          }}/>
          <h4>MultiSelect</h4>
          <MultiSelect data={options} value={{
            label: 'Selected option',
            value: 'value'
          }}/>
          <FileUpload
            label="Test Label"
            showFileNameInTextField={false}
            onFileLoaded={() => console.log('What is next?!!')}
            multi={false}
            required={false}
          />
          <h4>Spinner</h4>
            <Spinner model="playground.spinner" min={-12} max={25} value={4}/>
          <FormGroup>
            <ControlLabel>Textarea</ControlLabel>
            <FormControl componentClass="textarea" rows="3" placeholder="textarea"/>
          </FormGroup>
          <FormGroup>
            <Checkbox>
              Option one is this and that—be sure to include why it's great
            </Checkbox>
            <Checkbox disabled>
              Option two is disabled
            </Checkbox>
          </FormGroup>
          <FormGroup>
            <Radio name="radioGroup">
              Option one is this and that—be sure to include why it's great
            </Radio>
            {' '}
            <Radio name="radioGroup">
              Option two can be something else and selecting it will deselect option one
            </Radio>
            <Radio name="radioGroup" disabled>
              Option three is disabled
            </Radio>
          </FormGroup>
          <FormGroup>
            <h4>RangeSlider</h4>
            <RangeSlider model="playground.range_slider" value={75} min={0} max={100}/>
          </FormGroup>

        </Form>
        <h1>Dropdown</h1>
        <h1>Buttons</h1>
        <Button className="red-btn">Read More</Button>
        <Button disabled className="red-btn">Read More</Button>
        <br/><br/>
        <Button className="yellow-btn">Read More</Button>
        <Button disabled className="yellow-btn">Read More </Button>
        <br/><br/>
        <Button className="grey-btn">Read More</Button>
        <Button disabled className="grey-btn">Read More </Button>
        <br/><br/>
        <Button className="white-btn">Read More</Button>
        <Button disabled className="white-btn">Read More </Button>

        <br/><br/>
        <h1>Ghost Buttons</h1>
        <Button className="red-ghost-btn">Read More</Button>
        <Button disabled className="red-ghost-btn">Read More </Button>
        <br/><br/>
        <Button className="yellow-ghost-btn">Read More</Button>
        <Button disabled className="yellow-ghost-btn">Read More </Button>
        <br/><br/>
        <Button className="grey-ghost-btn">Read More</Button>
        <Button disabled className="grey-ghost-btn">Read More </Button>
        <br/><br/>
        <Button className="white-ghost-btn">Read More</Button>
        <Button disabled className="white-ghost-btn">Read More </Button>
        <br/><br/>
        <Button block className="red-ghost-btn">Read More</Button>

        <h1>Modals</h1>
        <Button className="red-btn" onClick={this.handleShow}>Open Modal</Button>
        <Modal className="user-frontend" show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              Modal Example
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Modal body content</div>
          </Modal.Body>
        </Modal>
      <h1>Data Tables</h1>
        <IgniteDataTable
          data={[
            { attributes: {
                name: 'First name',
                description: 'First description'
              }
            },
            { attributes: {
                name: 'Second name',
                description: 'Second description'
              }
            },
            { attributes: {
                name: 'Third name',
                description: 'Third description'
              }
            },
          ]}
          columns={[
            {
              prop: 'name',
              title: 'Name'
            },
            {
              prop: 'description',
              title: 'Description'
            },
          ]}
          pagination={{
            page: 1
          }}
          actions={[
            {
              label: 'Edit',
              color: 'grey',
            },
            {
              label: 'Delete',
            },
            {
              label: 'Disabled',
              disabled: (row) => {
                return true;
              },
            }
          ]}
        />
      </div>
    );
  }
}

export default SiteDesign;



// WEBPACK FOOTER //
// ./src/components/site-design/index.jsx